import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../../common/loading'
import { Content } from './Content'
import './i18n'
import { selectIsLoadingTransactionAndOrderStatus } from './store/slice'
import { getTransactionStatusAndOrderStatusThunk } from './store/thunk'

export const PreRender = () => {
  const dispatch = useDispatch()

  const isLoading = useSelector(selectIsLoadingTransactionAndOrderStatus)

  useEffect(() => {
    dispatch(getTransactionStatusAndOrderStatusThunk())
  }, [])

  if (isLoading) {
    return (
      <div className="positionRelative" style={{ height: 200 }}>
        <Loading />
      </div>
    )
  }

  return <Content />
}
